module.exports = __webpack_public_path__ + "img/16.905eb4c9.jpg";